import { defineStore } from 'pinia'

export const useBatchStore = defineStore('batchStore', {
    state: () =>({
        gmbatches: [],
        gmwbatches: [],
    }),
    persist: true,
    actions: {
        async setGMBatches(batches){
            this.gmbatches = batches
        },
        async setGMWBatches(batches){
            this.gmwbatches = batches
        }
    }
})